type GetAuthHeaders = () => Promise<Headers>;

let _getAuthHeaders: GetAuthHeaders | null = null;
const _baseUrl = import.meta.env.VITE_FRONTERA_REST_ENDPOINT || "";

/**
 * Registers the function used to obtain auth headers for private REST requests.
 * Should be called once from inside the Auth0 provider tree (e.g. AdminDataProvider)
 * so private endpoints can attach a Bearer token at request time.
 */
export const setRestAuthGetter = (fn: GetAuthHeaders) => {
  _getAuthHeaders = fn;
};

/**
 * Returns the current base URL for REST requests.
 */
export const getRestBaseUrl = () => _baseUrl;

/**
 * Returns auth headers from the registered getter, or null if no getter has been set
 * (e.g. on public routes where Auth0 is not mounted).
 */
export const getRestAuthHeaders = (): Promise<Headers | null> => {
  return _getAuthHeaders ? _getAuthHeaders() : Promise.resolve(null);
};
